import React from "react";

type StepperProps = {
  active: number;
  total: number;
};

const Stepper = ({ active, total }: StepperProps) => {
  return (
    <div className="flex gap-1 max-w-full">
      {[...Array(total)].map((number, index) => (
        <div
          key={index}
          className={`h-1 flex-1 ${
            index + 1 === active - 1 ? "bg-accentLight" : ""
          } ${index + 1 < active ? "bg-accent" : "bg-stepper"} `}
        ></div>
      ))}
    </div>
  );
};

export default Stepper;
